// vue
import { ref, computed, reactive, watch } from 'vue';

// store
import { useRefs } from '@store/ts/refs';

export default function (props: any, context: any) {
    // store
    const refs = useRefs();

    // vars
    const { _ } = window;
    const show = ref(false);
    const uncheckedList = ref();
    const checkedList = ref();
    const wasClosed = ref(false);

    watch(show, v => {
        if (!v) {
            wasClosed.value = true;
            addSelected();
        } else if(wasClosed.value) {
            setTimeout(() => {
                uncheckedList.value = null;
                checkedList.value = null;
            });
        }
    });

    watch(() => props.visible, v => {
        if (v) {
            show.value = true;
            if (props.data?.uncheckedList) {
                uncheckedList.value = props.data.uncheckedList;
            }
            if (props.data?.checkedList) {
                checkedList.value = props.data.checkedList;
            }
        } else {
            context.emit('changeFilter', [props.data.filter, [ -1 ]]);
            wasClosed.value = false;
        }
    });

    const checkedItems = computed(
        () => options.value
            .filter(({ checked }: { checked: boolean }) => checked)
            .map(({ id } : { id: number }) => id),
    );
    const allChecked = computed(() => options.value.every(({ checked }: { checked: boolean }) => checked));
    const checkedValues = computed(
        () => options.value
            .filter(({ checked }: { checked: boolean }) => checked)
            .map(({ id }: { id: string | number }) => id));
    // const payload = computed(() =>
    //     props.data?.allCheckedDefaultValue === null
    //         ? checkedItems.value
    //         : [-1]);

    const checkeds = computed(() => allChecked.value
        ? refs.localization.filters.all_select.all
        : options.value.reduce((accum: number, el: any) => accum + +el.checked , 0));

    const label = computed(() =>
        props.data.label[props.data.label.length - 1] === ':'
            ? props.data.label.slice(0, props.data.label.length - 1)
            : props.data.label,
    );

    const options = computed(() => props.data.refs.map((el: any) => {
        return reactive({
            // checked: !!_.get(props.filters, props.data.filter)?.find(exchange => exchange == el.id),
            checked:
                checkedList.value
                    ? checkedList.value.includes(el.id)
                    : uncheckedList.value
                        ? !uncheckedList.value.includes(el.id)
                        : _.get(props.filters, props.data.filter)[0] == -1
                            ? true
                            : !!~_.get(props.filters, props.data.filter)?.findIndex((item: string | number) => item == el.id),
            ...el,
        });
    }));

    const setCheckAll = ($event: any) => {
        options.value.forEach((el: any) => {
            el.checked = $event;
        });
    };

    const addSelected = () => {
        if (allChecked.value) {
            context.emit(
                'changeFilter',
                [ props.data.filter, checkedValues.value]);
        } else {
            context.emit('changeFilter', [ props.data.filter, checkedValues.value.length ? checkedValues.value : [ -1 ] ]);
        }
    };

    return {
        show,
        refs,
        label,
        options,
        checkeds,
        allChecked,
        _,
        setCheckAll,
    };
}